export default {
  head: {
    title: 'USSD apps',
    action: {
      create: {
        tooltip: 'Create new USSD app'
      }
    }
  },
  table: {
    emptyMsg: "You don't have any USSD app to display"
  },
  footer: {
    label: 'Apps created',
    tooltip:
      // eslint-disable-next-line max-len
      'If you reach the limit of created apps you will be unable to create new apps. To delete existing app or increase apps limit, please contact with Qrios support.'
  },
  dialog: {
    edit: {
      title: 'Edit USSD app'
    },
    create: {
      title: 'Create USSD app'
    }
  },
  form: {
    appUrl: {
      label: 'App URL',
      placeholder: 'Enter app url'
    },
    status: {
      label: 'Status'
    },
    debugEnabled: {
      label: 'Run this app in debug mode'
    },
    authorizationMethod: {
      label: 'Authorization method'
    },
    apiKey: {
      label: 'API key'
    }
  }
};
